import { GiftCardState } from './IProps'

export const isGiftCardBlockingSubmit = (
  giftCardInput: string,
  giftCardState: GiftCardState
): boolean => {
  if (giftCardInput.trim() === '') {
    return false
  }
  return giftCardState !== 'idle'
}
